/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse, HttpHandler, HttpEvent, HttpClient, HttpBackend, HttpResponseBase } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class WebWakeupInterceptor implements HttpInterceptor {
  private bypassInterceptorClient: HttpClient;
  constructor( private bypassInterceptorBackend: HttpBackend) {
    this.bypassInterceptorClient = new HttpClient(bypassInterceptorBackend);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.info("In WebWakeupInterceptor: ", request.url);
    return next
      .handle(request)
      .pipe(
        tap({
          next: (event) => {
            if (event instanceof HttpResponse) {
              this.wakeUpWeb(event as HttpResponseBase, "response");
            }
          },
          error: (error) => {
            if (error instanceof HttpErrorResponse) {
              this.wakeUpWeb(error as HttpResponseBase, "error");
            }
          }
        })
      );
  }

  wakeUpWeb(responseBase: HttpResponseBase, caller:string) {
    let eventStatus: number = responseBase.status;
    if (eventStatus !== 401) {
      this.bypassInterceptorClient.get('/qsmweb/Operation/WakeUp.ashx').subscribe({ complete: () => { }});
    }
   }
}
